import AlliancesLandingModule from './containers/alliancesLandingModule'

export {default as AlliancesLandingModuleLayout} from './components/alliancesLandingModuleLayout'

export default AlliancesLandingModule
